import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { useContext, useMemo, useCallback } from 'react'
import buildLoyaltySelectedUpgradeKey from 'loyalty/lib/benefits/buildLoyaltySelectedUpgradeKey'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'

function useLoyaltyOfferPageTargetStayUpgrade(
  originPackage: App.Package | App.HotelPackage | undefined,
): {
  selectedTargetUpgradeType: App.LoyaltyStayUpgradeType | undefined
  selectedTargetUpgradePackage: App.HotelPackage | undefined
  toggleTargetStayUpgrade: (selectedTargetUpgradeType: App.LoyaltyStayUpgradeType | undefined) => void
} {
  const { loyaltyTargetStayUpgradesSelected, offer } = useContext(OfferPageStateContext)

  const selectedUpgradeKey = useMemo(() => {
    if (!originPackage) return
    return buildLoyaltySelectedUpgradeKey(originPackage)
  }, [originPackage])

  const offerPageDispatch = useOfferPageDispatch()

  const selectedTargetUpgradeType = selectedUpgradeKey ? loyaltyTargetStayUpgradesSelected?.[selectedUpgradeKey] : undefined

  const targetUpgradePackage = useMemo<App.HotelPackage | undefined>(() => {
    if (!selectedTargetUpgradeType || !originPackage || !offer) return
    const targetUpgradePackageUniqueKey = originPackage.loyalty.upgradeTargetsUniqueKeys?.[selectedTargetUpgradeType]
    if (!targetUpgradePackageUniqueKey) return
    return offer.packages.find(pkg => pkg.uniqueKey === targetUpgradePackageUniqueKey)
  }, [selectedTargetUpgradeType, offer, originPackage])

  const toggleTargetStayUpgrade = useCallback((targetUpgradeType: App.LoyaltyStayUpgradeType) => {
    if (!selectedUpgradeKey) return
    offerPageDispatch({
      type: OfferPageActions.toggleLoyaltyTargetRoomUpgrade,
      selectedUpgradeKey,
      selectedTargetUpgradeType: targetUpgradeType,
    })
  }, [offerPageDispatch, selectedUpgradeKey])

  return {
    selectedTargetUpgradeType,
    selectedTargetUpgradePackage: selectedTargetUpgradeType ? targetUpgradePackage : undefined,
    toggleTargetStayUpgrade,
  }
}

export default useLoyaltyOfferPageTargetStayUpgrade
